export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		MODERATOR: 2,
		CLIENT: 3,
		CLIENT_MODERATOR: 4
	},
	USER: {
		VERIFIED: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		},
		STATUS: {
			PENDING: 0,
			ACTIVE: 1,
			INACTIVE: 2,
		}
	},
	MODULES: {
		GRAPHICS: 1,
		KYC: 3,
		DOCUMENTS: 4,
		FRAUD: 5,
		BLACK_LIST: 6,
		CONFIG: 7,
		USERS: 8,
	    VERIFICATION_PLANS: 9,
	    DOCUMENT_PLANS: 10,
	    ADMIN_KYC: 11,
	    ADMIN_DOCUMENTS: 12,
	    ADMIN_FRAUD: 13,
	    ADMIN_BLACK_LIST: 14,
	    ADMIN_CONFIG: 15,
	    MODERATORS: 16,
	    ADMIN_MODERATORS: 17,
	    SYSTEM_MOVEMENTS: 18,
	    ADMIN_SYSTEM_MOVEMENTS: 19,
	    BILL_PLANS: 20,
	    ADMIN_BILLS: 21,
	    BILLS: 22,
	    ADMIN_HOME: 23
	},
	IDENTITY_VERIFICATION_RESULT: {
	    YES: 1,
	    NO: 0,
	    UNFINISH: -1
	},
	S3: {
	    YES: 1,
	    NO: 0
	},
	CHANGE_VERIFICATION_TYPES: {
		DOCUMENT: 1,
		FACE: 2,
		LIVENESS: 3,
		RESULT: 4,
	},
	ORIGINS: {
		ANDROID: 1,
		IOS: 2,
		WEB: 3
	},
	IS_VEHICLE: {
	    YES: 1,
	    NO: 0
	},
	MESSAGE_LENGTH: {
	    SHORT: 1,
	    MEDIUM: 2,
	    LARGE: 3
	},
	DOCUMENT_TYPES: {
		V: 1,
		E: 2,
		G: 3,
		J: 4,
		PASSPORT: 5
	},
	BRAVEALO_DOCUMENT_TYPES: {
		ID: 1,
		PASSPORT: 2,
		VEHICLE_CARD: 3,
		MEDICAL_CERTIFICATE: 4,
		DRIVER_LICENSE: 5,
		RIF: 6,
		VOUCHER: 7,
		RACDA: 8,
		ROCT: 9,
		INSOPESCA: 10,
		RCV: 11,
		HEALTH_PERMIT: 12,
		RESQUIMC: 13,
		PLATE: 14,
		HEALTH_CERTIFICATE: 15,
    	FOOD_HANDLING: 16,
    	CASH: 17,
    	VOUCHER_WITHOUT_DATA: 18,
    	COLOMBIAN_ID: 19,
    	COLOMBIAN_VOUCHER: 20,
    	GENERIC_ID: 21,
    	COLOMBIAN_NIT: 22
	},
	S3_PROVIDERS: {
		CONTABO: 1,
		AWS: 2
	},
	CONFIG_TYPES: {
	  KYC: 1,
	  DOCUMENTS: 2,
	  BILLS: 3
	},
	SYSTEM_MOVEMENT_MODULES: {
	    KYC: 1,
	    DOCUMENTS: 2,
	    CONFIG: 3,
	    BILLS: 4
	},
	BILL_VERIFICATION_STATUS: {
		VERIFIED: 1,
		WARNING: 0
	},
	VERIFICATION_CASES: {
		DOCUMENT: 1,
		AGE: 2,
		BIRTHDATE: 3,
		FACE: 4,
		LIVENESS: 5,
		DOCUMENT_OBJECT: 6,
		DOCUMENT_INVALID: 7,
	    DOCUMENT_INCOMPLETE: 8,
	    DOCUMENT_EXPIRED: 9,
	    DOCUMENT_COMPARISON: 10,
	    TYPOGRAPHY_ALTERATION: 11,
	    LAYOUT_ALIGNMENT_ALTERATION: 12,
	    COPY_ICON_ALTERATION: 13,
	    TEXTURE_ALTERATION: 14,
	    LOCAL_COMPRESSION_ALTERATION: 15,
	    TEXT_BORDER_HALO: 16,
	    CLEAN_PATCH: 17,
	    CLONED_TEXTURE: 18,
	    ANOMALOUS_LOCAL_SHARPNESS: 19,
	    MULTIPLE_ANOMALIES: 20,
	    FORM_INVALID: 21,
	    PHONE_INVALID: 22,
	    AMOUNT_INVALID: 23,
	    DATE_INVALID: 24,
	    REFERENCE_INVALID: 25,
	    BANK_INVALID: 26,
	    INVALID_STATUS: 27,
	    INVALID_PLATE: 28,
	    INVALID_COUNTRY: 29
	},
}